/*
  SFSX Slide Tabs — sliding-pill toggle for the EasyTabs app on product pages.
  Port of the 21st.dev SlideTabs idea (black pill follows the pointer, snaps
  back to the selected tab when the pointer leaves) without React or
  framer-motion: the pill is the tab strip's ::before, positioned by two CSS
  variables, and the spring is a CSS cubic-bezier with a little overshoot.

  EasyTabs owns the markup, the click handling and the panels. This file never
  changes which tab is selected; it only watches the app's own
  "easytabs-active" class and moves the pill to match. If this script fails to
  load, nothing is marked with data-sfsx-slide and the app looks as it did.
*/
(function(){
  if (window.__sfsxSlideTabs) return;
  window.__sfsxSlideTabs = 1;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function items(ul){ return ul.querySelectorAll(':scope > li.easytabs-tab-item'); }
  function active(ul){ return ul.querySelector(':scope > li.easytabs-active') || items(ul)[0]; }

  function place(ul, li, still){
    if (!li || !ul.offsetWidth) return;
    var jump = still || reduce.matches;
    if (jump) ul.setAttribute('data-sfsx-still', '');
    ul.style.setProperty('--sfsx-tab-x', li.offsetLeft + 'px');
    ul.style.setProperty('--sfsx-tab-w', li.offsetWidth + 'px');
    ul.style.setProperty('--sfsx-tab-o', '1');
    // Explicit text colour: white only on the tab the pill is under.
    var all = items(ul);
    for (var i = 0; i < all.length; i++){
      if (all[i] === li) all[i].setAttribute('data-sfsx-on', '');
      else all[i].removeAttribute('data-sfsx-on');
    }
    if (jump){
      void ul.offsetWidth;
      setTimeout(function(){ ul.removeAttribute('data-sfsx-still'); }, 40);
    }
  }

  // On a narrow screen the pill scrolls sideways; keep the chosen tab in view.
  function reveal(ul, li){
    if (!li || ul.scrollWidth <= ul.clientWidth) return;
    var left = li.offsetLeft - 24;
    var right = li.offsetLeft + li.offsetWidth + 24;
    if (left < ul.scrollLeft) ul.scrollTo({ left: left, behavior: reduce.matches ? 'auto' : 'smooth' });
    else if (right > ul.scrollLeft + ul.clientWidth) ul.scrollTo({ left: right - ul.clientWidth, behavior: reduce.matches ? 'auto' : 'smooth' });
  }

  function bind(ul){
    if (ul.hasAttribute('data-sfsx-slide') || !items(ul).length) return;
    ul.setAttribute('data-sfsx-slide', '');
    var current = active(ul);
    place(ul, current, true);
    reveal(ul, current);

    ul.addEventListener('mouseover', function(e){
      var li = e.target.closest('li.easytabs-tab-item');
      if (li && li.parentNode === ul) place(ul, li);
    });
    ul.addEventListener('mouseleave', function(){ place(ul, active(ul)); });
    ul.addEventListener('focusin', function(e){
      var li = e.target.closest('li.easytabs-tab-item');
      if (li && li.parentNode === ul){ place(ul, li); reveal(ul, li); }
    });

    new MutationObserver(function(){
      var a = active(ul);
      if (a !== current){ current = a; place(ul, a); reveal(ul, a); }
    }).observe(ul, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-selected'] });

    if ('ResizeObserver' in window){
      new ResizeObserver(function(){ place(ul, active(ul), true); }).observe(ul);
    }
    if (document.fonts && document.fonts.ready){
      document.fonts.ready.then(function(){ place(ul, active(ul), true); });
    }
  }

  var queued = false;
  function scan(){
    queued = false;
    var lists = document.querySelectorAll('ul.easytabs-tabs');
    for (var i = 0; i < lists.length; i++) bind(lists[i]);
  }
  function queue(){ if (!queued){ queued = true; setTimeout(scan, 60); } }

  scan();
  // EasyTabs builds its markup after page load, so watch for it for a while.
  var watcher = new MutationObserver(queue);
  watcher.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function(){ watcher.disconnect(); scan(); }, 20000);
  document.addEventListener('shopify:section:load', queue);
})();

/*
  SFSX product page, part 2: keep the buy box first on phones.

  The "Frequently bought together" app (cbb-frequently-bought-container)
  injects itself into .product-gallery. With two columns that puts it under
  the photos on the left, which is fine. When the page stacks on a phone the
  gallery comes first, so the bundle list landed ABOVE the title, price and
  Add to cart. Same on the live theme; not caused by the 9/23 draft.

  While the columns are stacked, the widget is moved to just after the
  Add to cart form block. If the page widens back into two columns it is
  returned to exactly where the app put it (a comment marker holds the spot).
  The node is moved, not copied, so the app's own handlers keep working.
*/
(function(){
  if (window.__sfsxBundleMove) return;
  window.__sfsxBundleMove = 1;

  function start(){
    var gallery = document.querySelector('.product-gallery');
    var main = document.querySelector('.product-main');
    if (!gallery || !main) return;
    var moved = [];

    function stacked(){
      var g = gallery.getBoundingClientRect(), m = main.getBoundingClientRect();
      if (!g.width || !m.width) return false;
      return Math.abs(g.left - m.left) < 8 && m.top >= g.top;
    }

    function sweep(){
      var form = main.querySelector('.product-block--form');
      if (stacked() && form){
        var found = gallery.querySelectorAll(':scope > .cbb-frequently-bought-container');
        for (var i = 0; i < found.length; i++){
          var w = found[i];
          var mark = document.createComment('sfsx-bundle-home');
          w.parentNode.insertBefore(mark, w);
          form.parentNode.insertBefore(w, form.nextSibling);
          w.setAttribute('data-sfsx-moved', '');
          w.style.marginTop = '24px';
          moved.push({ w: w, mark: mark });
        }
      } else if (!stacked() && moved.length){
        moved.forEach(function(m){
          if (m.mark.parentNode && m.w.isConnected) m.mark.parentNode.insertBefore(m.w, m.mark);
          if (m.mark.parentNode) m.mark.parentNode.removeChild(m.mark);
          m.w.removeAttribute('data-sfsx-moved');
          m.w.style.marginTop = '';
        });
        moved = [];
      }
    }

    var t = 0;
    function later(){ clearTimeout(t); t = setTimeout(sweep, 80); }

    sweep();
    // The app injects after load (and may re-render), so keep an eye on the gallery.
    new MutationObserver(later).observe(gallery, { childList: true });
    window.addEventListener('resize', later);
    window.addEventListener('orientationchange', later);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();